<template>
  <Dialog v-model:visible="visible" modal :header="title" :style="{ width: '35rem' }" @hide="onCloseDialog(false)">
    <Message v-if="severity" :severity="severity" variant="simple" size="small" class="modal-body my-4" v-html="message"/>
    <div v-if="!severity" class="modal-body my-4" v-html="message"></div>
    <div class="flex justify-end gap-2">
      <Button type="button" :label="t('components.dialog.ok')" severity="secondary" @click="onCloseDialog(true)"></Button>
      <Button v-if="type === DIALOG_TYPE.CONFIRM" type="button" :label="t('components.dialog.cancel')" @click="onCloseDialog(false)"></Button>
    </div>
  </Dialog>
</template>

<script setup lang="ts">
import { t } from 'i18next';
import { computed, ref } from 'vue';
import { Dialog, Button, Message } from 'primevue';
import { DIALOG_TEXT_TYPE, DIALOG_TYPE } from './constants';

const props = defineProps<{
  title: string,
  message: string,
  type: DIALOG_TYPE,
  textType?: DIALOG_TEXT_TYPE,
  onClose: (answer: boolean) => void,
}>();
const visible = ref(true);
const severityValues = {
  [DIALOG_TEXT_TYPE.INFO]: 'info',
  [DIALOG_TEXT_TYPE.WARNING]: 'warn',
  [DIALOG_TEXT_TYPE.ERROR]: 'error',
  [DIALOG_TEXT_TYPE.SUCCESS]: 'success',
};
const severity = computed(() => {
  if (props.textType) {
    return severityValues[props.textType];
  }

  return null;
});
const onCloseDialog = (answer: boolean): void => {
  visible.value = false;
  props.onClose(answer);
};
</script>
